import { Component, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { RoutingService } from '../../angular-wallet-base/services/routing.service';
import { AppState, getUserVestingState } from '../../angular-wallet-base/store/appState';
import {
VestingLtcStateInitRequestAction,

} from "../../angular-wallet-base/actions/vestingLTC.actions";
import { OneInchService } from 'src/app/angular-wallet-base/services/one-inch.service';
import { ToastController, ModalController } from '@ionic/angular';
import { PinModalComponent } from 'src/app/components/pin-modal/pin-modal.component';
import { AUTH_REASON, TRADE_SLIPPAGE } from 'src/app/angular-wallet-base/constants';


@Component({
  selector: 'app-vest-ltc-profile',
  templateUrl: './vest-ltc.page.html',
  styleUrls: ['./vest-ltc.page.scss'],
})

export class VestLtcPage implements OnInit {
  @ViewChild('popover') popover;
  public vestingUserInfo = {
      ltcBalance: null,
      hasDeposited: false,
      isStaking: false,
      vestingInfo: {
        depositTimestamp: new Date(0),
        depositBalance: 200,
        amountClaimed: 0,
        claimableBalance: 0,
      },
      stakingInfo: {
        amountStaked: 0,
        interestEarned: 0,
        interestClaimed: 0,
      },
  };
  public  message: string = null;
  public loading: boolean = true;
  public error: boolean = false;
  public isOpen:boolean = false;
  public  info: string = null;

  constructor(
   private routingService: RoutingService,
   protected store: Store<AppState>,
   private toastController: ToastController,
   private modalCtrl: ModalController,
   private oneInchService: OneInchService,
  ) {
 

  }

  async ngOnInit() {
    await this.oneInchService.initiateConnection();
    const modal = await this.modalCtrl.create({
      component: PinModalComponent,
      backdropDismiss: false,
      cssClass: 'fullscreen-modal',
      componentProps: {
        reason: AUTH_REASON.VESTING_CONNECT_SIGN
      },
      id: 'pinModal'
    });
    await modal.present();


    this.store.select(getUserVestingState).subscribe(user => {
        this.vestingUserInfo = user.userVestingLTC;
        this.loading = user.loading;
        this.error = user.error;
        this.message = user.message;
        if(this.message.length > 1) {
          this.presentToast(this.message, this.error);
        }
    }) 
  }

  async goBack() {
    await this.routingService.goHome();
  }

  presentPopover(e: Event, action) {
    this.popover.event = e;
    this.isOpen = true;
    if (action === 'Claim') {
        this.info = 'The LODE claimable balance will be deposited into your Vault wallet. If you claim your balance, you will not be able to stake this balance afterwards.';
    } else if (action === 'Stake') {
        this.info = 'Place your LODE claimable balance into a staking scheme, where you’ll earn a fee as a reward for your service to strengthen the protocol.';
    } else if (action === 'Unstake') {
        this.info = 'The LODE staked and fee amounts will be deposited into your Vault wallet. You will not be able to stake this balance again.';
    }
  }

  async handleDeposit() {
    this.loading = true;
    await this.oneInchService.initiateConnection();
    const modal = await this.modalCtrl.create({
      component: PinModalComponent,
      backdropDismiss: false,
      cssClass: 'fullscreen-modal',
      componentProps: {
        reason: AUTH_REASON.VESTING_DEPOSITE_SIGN
      },
      id: 'pinModal'
    });
    await modal.present();

  }

  async handleClaim() {
    this.loading = true;
    await this.oneInchService.initiateConnection();
    const modal = await this.modalCtrl.create({
      component: PinModalComponent,
      backdropDismiss: false,
      cssClass: 'fullscreen-modal',
      componentProps: {
        reason: AUTH_REASON.VESTING_CLAIM_SIGN
      },
      id: 'pinModal'
    });
    await modal.present();

  }

  bigInt(weiValue: bigint) {
    return parseFloat((Number(weiValue) / (10 ** 17)).toFixed(6))
  }

  async handleStake() {
    this.loading = true;
    await this.oneInchService.initiateConnection();
    const modal = await this.modalCtrl.create({
      component: PinModalComponent,
      backdropDismiss: false,
      cssClass: 'fullscreen-modal',
      componentProps: {
        reason: AUTH_REASON.VESTING_STAKE_SIGN
      },
      id: 'pinModal'
    });
    await modal.present();
  }

  async handleUnStake() {
    this.loading = true;
    await this.oneInchService.initiateConnection();
    const modal = await this.modalCtrl.create({
      component: PinModalComponent,
      backdropDismiss: false,
      cssClass: 'fullscreen-modal',
      componentProps: {
        reason: AUTH_REASON.VESTING_UNSTAKE_SIGN
      },
      id: 'pinModal'
    });
    await modal.present();
  }

  async presentToast(message: string, error) {
    const toast = await this.toastController.create({
      message: message,
      color: error ? 'success' : 'warning',
      duration: 3000, // Duration in milliseconds
      position: 'top' // Position of the toast message
    });
    toast.present();
  }
}
